import React, { Fragment } from 'react'
import Navbar2 from '../../components/Navbar2/Navbar2'
import PageTitle from '../../components/pagetitle/PageTitle'
import CirclesTeaser from '../../components/csp/CirclesTeaser'
import CtaSection from '../../components/CtaSection/CtaSection'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { features } from '../../content/csp'

const PlatformPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <PageTitle pageTitle={'CSPNow'} pagesub={'Platform'} />
      <section className="csp-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <span className="csp-kicker">The platform</span>
              <h2 className="csp-title">
                Communication and surveys for the political center.
              </h2>
              <p className="csp-lead">
                CSPNow has a web application and a mobile app. Members work
                inside Circles. The features below are what is in the web
                platform today.
              </p>
            </div>
          </div>
          <div style={{ marginTop: 48 }}>
            {features.map((feature) => (
              <article className="csp-feature-row" key={feature.id}>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
      <CirclesTeaser />
      <CtaSection ctaClass={'wpo-cta-section-s2 pb-0'} />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}

export default PlatformPage
